import { FEATURE_FLAGS, STORAGE_KEY_FLAGS } from "./constants";

// ---------------------------------------------------------------------------
// Storage helpers for feature flags
// ---------------------------------------------------------------------------

export function loadFlags(): Record<string, boolean> {
  try {
    const stored = localStorage.getItem(STORAGE_KEY_FLAGS);
    if (stored) return JSON.parse(stored) as Record<string, boolean>;
  } catch {
    // Ignore parse errors
  }
  // Default: all flags off
  const defaults: Record<string, boolean> = {};
  for (const flag of FEATURE_FLAGS) {
    defaults[flag.key] = false;
  }
  return defaults;
}

export function saveFlags(flags: Record<string, boolean>): void {
  localStorage.setItem(STORAGE_KEY_FLAGS, JSON.stringify(flags));
}
